/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export enum AuthMode {
  Standalone = 'standalone',
  SAML = 'saml',
  Google = 'google',
}

interface SamlSettingsAdvanceSecurity {
  nameIdEncrypted: boolean;
  authnRequestsSigned: boolean;
  logoutRequestSigned: boolean;
  logoutResponseSigned: boolean;
  signMetadata: boolean;
  wantMessagesSigned: boolean;
  wantAssertionsSigned: boolean;
  wantAssertionsEncrypted: boolean;
  wantNameId: boolean;
  wantNameIdEncrypted: boolean;
  wantAttributeStatement: boolean;
  requestedAuthnContext: boolean;
  requestedAuthnContextComparison: string | string[];
  failOnAuthnContextMismatch: boolean;
  metadataValidUntil: null | string;
  metadataCacheDuration: null | string;
  signatureAlgorithm: string;
  digestAlgorithm: string;
}

interface SamlSettingsAdvance {
  security: SamlSettingsAdvanceSecurity;
}

interface SamlSettingsCert {
  datetime: string;
  value: string;
}

export interface SamlSettings {
  url: string;
  fileContent: string;
  advance: SamlSettingsAdvance;
  idpCerts: SamlSettingsCert[];
  idpEntityId: string;
  idpSloUrl: string;
  idpSsoUrl: string;
  // Service provider data
  spCerts: SamlSettingsCert[];
  spEntityId: string;
  spAssertionConsumerUrl: string;
  spSloUrl: string;
  spNameIdFormat: string;
  // Other data to create derived values
  zengrcUrl: string;
}

export interface AuthenticationSettings {
  selectedAuthModes: string[];
  lastLoggedInWithSaml: Date | null;
  lastEditionDateSaml: Date | null;
  debugMode: boolean;
  samlConfigurationReady: boolean;
  samlGroupsEnabled: boolean;
  overrideEnableStandaloneLogin: boolean;
  overrideEnableGoogleLogin: boolean;
}
